import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { withStyles } from '@mui/styles';
import { withRouter } from 'utils';
import { Typography, Tabs, Tab } from '@mui/material';

const styles = (theme) => ({
  container: {
    backgroundColor: theme.palette.primary.accent,
  },
  header: {
    padding: theme.spacing(3),
    paddingBottom: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
  },
  headerTitle: {
    color: '#FFFFFF',
    fontSize: 24,
    paddingRight: 30,
  },
  tabs: {
    paddingTop: 3,
    paddingLeft: theme.spacing(3),
  },
  indicator: {
    backgroundColor: '#FFFFFF',
    height: 2,
    marginBottom: 8,
  },
  headerDivider: {},
  tabPanel: {
    color: '#E0E0E0',
    '&.Mui-selected': {
      color: '#FFFFFF',
    },
    '&:hover': {
      color: '#FFFFFF',
    },
  },
});

// Each tab is backed by a real route so it gets its own URL (deep-linkable,
// back-button friendly). `value` is the active-tab key each page passes in;
// `path` is where clicking the tab navigates. Client Usage and Activity Log
// reuse existing routes; Client vs Client lives at /usage/compare and All Users
// (every customer user across every client) at /usage/users.
const ANALYTICS_TABS = [
  { value: 'usage', label: 'Client Usage', path: '/usage' },
  { value: 'compare', label: 'Client vs Client', path: '/usage/compare' },
  { value: 'users', label: 'All Users', path: '/usage/users' },
  { value: 'activity', label: 'Activity Log', path: '/activity' },
];

class AnalyticsTabs extends React.Component {
  render() {
    const { tab, classes } = this.props;

    return (
      <div className={classes.container}>
        <title>Analytics</title>
        <div className={classes.header}>
          <Typography className={classes.headerTitle}>Analytics</Typography>
        </div>
        <Tabs
          variant='scrollable'
          TabIndicatorProps={{ className: classes.indicator }}
          className={classes.tabs}
          value={tab}
          onChange={this.onTabChange}
        >
          {ANALYTICS_TABS.map((t) => (
            <Tab
              key={t.value}
              className={classes.tabPanel}
              label={t.label}
              value={t.value}
              disableRipple
            />
          ))}
        </Tabs>
      </div>
    );
  }

  onTabChange = (event, newValue) => {
    const found = ANALYTICS_TABS.find((t) => t.value === newValue);
    this.props.router.navigate(found ? found.path : `/${newValue}`);
  };
}

AnalyticsTabs.propTypes = {
  router: PropTypes.object.isRequired,
  classes: PropTypes.object,
  tab: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

const styled = withStyles(styles)(AnalyticsTabs);
const connected = connect(mapStateToProps)(styled);
const routed = withRouter(connected);
export { routed as AnalyticsTabs };
export default routed;
